<template>
  <van-field class="t_vant_field" v-bind="$attrs" :type="passwordType" v-on="$listeners">
    <template slot="right-icon" v-if="showPassword">
      <span class="solts" @click="switchPasswordType">
        <van-icon name="eye" v-if="passwordType==='password'" />
        <van-icon name="closed-eye" v-else />
      </span>
    </template>
    <!-- 遍历子组件非作用域插槽，并对父组件暴露 -->
    <template v-for="(index, name) in $slots" v-slot:[name]>
      <slot :name="name" />
    </template>
    <!-- 遍历子组件作用域插槽，并对父组件暴露 -->
    <template v-for="(index, name) in $scopedSlots" v-slot:[name]="data">
      <slot :name="name" v-bind="data"></slot>
    </template>
  </van-field>
</template>

<script>
export default {
  name: 'TVanField',
  props: {
    showPassword: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    }
  },
  data() {
    return {
      passwordType: this.type
    }
  },
  methods: {
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
    }
  }
}
</script>
<style lang="scss" scoped>
.t_vant_field {
  .van-field__right-icon {
    .solts {
      right: -15px;
    }
  }
}
</style>
